export default "__VITE_ASSET__DHGoPz4h__"